import {of} from "rxjs"
import {AnyAction} from "redux"
import {isActionOf} from "typesafe-actions"
import {catchError, filter, map, mergeMap, switchMap} from "rxjs/operators"
import {ActionsObservable, StateObservable} from "redux-observable"

// Models
import {DataResponse} from "../../../http/models"
import {SignInResponse, User} from "../../models"
import {EpicDependencies, RootState} from "../../../../models"

// Constants
import {AuthRequestProperty} from "../../constants"

// Actions
import * as a from "../actions"

// Utils
import Utils from "../../../../utils/Utils"

/**
 * @param action$
 * @param _
 * @param d
 */
export const signInEpic = (action$: ActionsObservable<AnyAction>, _: StateObservable<RootState>, d: EpicDependencies) => {
    return action$.pipe(
        filter(isActionOf(a.signInAsync.request)),
        switchMap(({payload: {username, password}}) => {
            const requestDto = new FormData();

            requestDto.append(AuthRequestProperty.USERNAME, username);
            requestDto.append(AuthRequestProperty.PASSWORD, password);
            requestDto.append(AuthRequestProperty.GRANT_TYPE, AuthRequestProperty.PASSWORD);

            return d.authService.signIn(requestDto).pipe(
                map(response => {
                    const {access_token, expires_in, details}: SignInResponse = response.response;

                    // TODO: check role if required
                    d.authService.saveToken(access_token, expires_in);

                    return a.signInAsync.success(details)
                }),
                catchError(err => of(a.signInAsync.failure(Utils.extractResponseErrorMessage(err).message))),
            )
        }),
    )
};

/**
 * @param action$
 * @param _
 * @param d
 */
export const signOutEpic = (action$: ActionsObservable<AnyAction>, _: StateObservable<RootState>, d: EpicDependencies) => {
    return action$.pipe(
        filter(isActionOf(a.signOutAsync.request)),
        switchMap(() => d.authService.signOut().pipe(
            map(() => a.signOutAsync.success()),
            catchError(err => of(a.signOutAsync.success())), // Success anyway
        )),
    )
};

/**
 * @param action$
 * @param _
 * @param d
 */
export const fetchCurrentUserEpic = (action$: ActionsObservable<AnyAction>, _: StateObservable<RootState>, d: EpicDependencies) => {
    return action$.pipe(
        filter(isActionOf(a.fetchCurrentUserAsync.request)),
        mergeMap(() => {
            return d.authService.fetchCurrentUser().pipe(
                map(response => {
                    const {data}: DataResponse<User> = response.response;

                    return a.fetchCurrentUserAsync.success(data)
                }),
                catchError(err => of(a.fetchCurrentUserAsync.failure(err))),
            )
        }),
    )
};
